import { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"

export type Action = {
    icon?: string;
    label: string;
    onClick?: () => void;
    href?: string;
    disabled?: boolean;
};

type ActionMenuProps = {
    actions: Action[];
};

export const ActionMenu: React.FC<ActionMenuProps> = ({ actions }) => {
    const [isMenu, setIsMenu] = useState(false);


    const toggleMenu = () => {
        setIsMenu(!isMenu);
    };

    return (
        <Dropdown isOpen={isMenu} toggle={toggleMenu} className="float-end ms-2">
            <DropdownToggle tag="a" className="text-muted">
                <i className="mdi mdi-dots-horizontal font-size-18" />
            </DropdownToggle>
            <DropdownMenu>
                {actions.map((action, idx) => (
                    <DropdownItem
                        key={idx}
                        onClick={action.onClick}
                        href={action.href}
                        disabled={action.disabled}
                    >
                        <i className={`${action.icon}`}/>{" "}{action.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};